import * as constants from '../constants';

export function setPopUpNotificationText(payload) {
  return {
    type: constants.SET_POP_UP_NOTIFICATION_TEXT,
    payload
  };
}
